<template>
  <div
    class="progress-card"
    @mouseover="showOverall = true"
    @mouseleave="showOverall = false"
  >
    <div v-if="error" class="error-msg">{{ error }}</div>

    <!-- Section progress bar -->
    <div class="bar-wrapper">
      <div class="bar-header">
        <span class="bar-label">{{ currentSection ? currentSection.title : 'Current Section' }}</span>
        <span class="bar-pct">{{ sectionPercentage }}%</span>
      </div>
      <div class="track">
        <div class="bar section-fill" :style="{ width: sectionPercentage + '%' }"></div>
      </div>
      <div class="sub-label">
        {{ currentSection ? currentSection.answered : 0 }} of
        {{ currentSection ? currentSection.required : 0 }} required questions answered
      </div>
    </div>

    <!-- Overall progress panel (slides down on hover) -->
    <div class="overall-panel" :class="{ visible: showOverall }">
      <div class="bar-wrapper overall-bar-wrapper">
        <div class="bar-header">
          <span class="bar-label">Overall</span>
          <span class="bar-pct">{{ overallPercentage }}%</span>
        </div>
        <div class="track overall-track">
          <div class="bar overall-fill" :style="{ width: overallPercentage + '%' }"></div>
        </div>
        <div class="sub-label">
          {{ status.overall.answered }} of {{ status.overall.required }} required questions answered
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyProgress',
  props: {
    fetchUrl: {
      type: String,
      required: true
    },
    activeSectionId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      status: {
        overall: { answered: 0, required: 0 },
        sections: []
      },
      showOverall: false,
      loading: false,
      error: null
    }
  },
  computed: {
    overallPercentage() {
      const { answered, required } = this.status.overall
      if (!required) return 0
      return Math.min(100, Math.round((answered / required) * 100))
    },
    currentSection() {
      return this.status.sections.find(s => s.id === this.activeSectionId) || null
    },
    sectionPercentage() {
      if (!this.currentSection || !this.currentSection.required) return 0
      return Math.min(100, Math.round((this.currentSection.answered / this.currentSection.required) * 100))
    }
  },
  watch: {
    '$store.state.survey.lastSaved'() {
      this.fetchStatus()
    },
    activeSectionId() {
      this.fetchStatus()
    }
  },
  mounted() {
    this.fetchStatus()
  },
  methods: {
    fetchStatus() {
      this.loading = true
      this.error = null
      this.$http.get(this.fetchUrl)
        .then(response => {
          this.status = response.data
        })
        .catch(err => {
          this.error = 'Could not load progress.'
          console.error('SurveyProgress fetch error:', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.progress-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  cursor: default;
}

.bar-wrapper {
  margin-bottom: 4px;
}

.bar-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 13px;
}

.bar-label {
  font-weight: 600;
}

.bar-pct {
  color: #555;
}

.track {
  background: #e0e0e0;
  border-radius: 5px;
  height: 10px;
  overflow: hidden;
}

.overall-track {
  height: 8px;
}

.bar {
  height: 100%;
  border-radius: 5px;
  transition: width 0.4s ease;
}

.section-fill {
  background: #43a047;
}

.overall-fill {
  background: #1976d2;
}

.sub-label {
  font-size: 11px;
  color: #777;
  margin-top: 3px;
}

.error-msg {
  font-size: 12px;
  color: #c62828;
  margin-bottom: 8px;
}

.overall-panel {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, opacity 0.4s ease;
}

.overall-panel.visible {
  max-height: 80px;
  opacity: 1;
}

.overall-bar-wrapper {
  padding-top: 8px;
}
</style>
